import { version as reactVersion } from 'react';

// Mirrors directv-design-system/atoms/inert-slot.ts; src/ has no import from
// directv-design-system today, so the version check is reproduced locally
// rather than crossing that boundary.
export const INERT_SLOT: { inert?: boolean } =
  Number.parseInt(reactVersion, 10) >= 19 ?
    { inert: true } :
    ({ inert: '' } as unknown as { inert?: boolean });
